module.exports = __webpack_public_path__ + "img/EA120_1-1.04246a09.jpg";